import { FormattedWorkflowTemplateDetails } from "@idw-types/data/workflow-template-details";

export enum WorkflowTemplateDetailsActionTypes {
    // Workflow Template Details
    SET_WORKFLOW_TEMPLATE_DETAILS_LOADING = "SET_WORKFLOW_TEMPLATE_DETAILS_LOADING",
    SET_WORKFLOW_TEMPLATE_DETAILS = "SET_WORKFLOW_TEMPLATE_DETAILS"
}

// Workflow Template Details
type SetWorkflowTemplateDetailsLoadingAction = {
    type: WorkflowTemplateDetailsActionTypes.SET_WORKFLOW_TEMPLATE_DETAILS_LOADING,
    payload: { isLoading: boolean; }
};

export const setWorkflowTemplateDetailsLoading = (isLoading: boolean): SetWorkflowTemplateDetailsLoadingAction => ({
    type: WorkflowTemplateDetailsActionTypes.SET_WORKFLOW_TEMPLATE_DETAILS_LOADING,
    payload: { isLoading }
});

type SetWorkflowTemplateDetailsAction = {
    type: WorkflowTemplateDetailsActionTypes.SET_WORKFLOW_TEMPLATE_DETAILS,
    payload: { workflowTemplate: FormattedWorkflowTemplateDetails; }
}

export const setWorkflowTemplateDetails = (workflowTemplate: FormattedWorkflowTemplateDetails): SetWorkflowTemplateDetailsAction => ({
    type: WorkflowTemplateDetailsActionTypes.SET_WORKFLOW_TEMPLATE_DETAILS,
    payload: { workflowTemplate }
});

export type WorkflowTemplateDetailsActions =
    // Workflotw Template Details
    SetWorkflowTemplateDetailsLoadingAction |
    SetWorkflowTemplateDetailsAction;
     